import {
  PlanningPortalGlobalState
} from "planning-portal-library/src/lib/presentation/state/planning-portal-global-state/planning-portal-global.state";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import { Authorize } from "../../../../core/domain";
import { Router } from "@angular/router";
import { Login } from "../../../state/planning-portal-global-state/planning-portal-global.actions";
import { Observable, catchError, throwError } from "rxjs";
import { JwtHelperService } from "@auth0/angular-jwt";
import { RefreshTokenUseCase } from "planning-portal-library/src/lib/core/usecases/account/refreshToken.usecase";
import { RefreshToken } from "planning-portal-library/src/lib/core/domain/models/refresh-token";
import { ProductPortalConstants } from "planning-portal-library/src/lib/data/shared/application-constants/product-portal-constants";


@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  

  constructor(
    private store: Store,
    private router: Router,
    private refreshTokeUseCase: RefreshTokenUseCase
  ) {}

  private isRefreshing = false;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const authorize = this.store.selectSnapshot<Authorize | undefined>(
      PlanningPortalGlobalState.Authorize
    );
    const jwtHelper = new JwtHelperService();
    const isAuthenticated = authorize && authorize.token;

    if (isAuthenticated) {
      const expiration = jwtHelper.getTokenExpirationDate(authorize!.token)!;
      const date = new Date();

      const milliDiff: number = expiration.getTime() - date.getTime();

      const totalSeconds = Math.floor(milliDiff / 1000);

      const totalMinutes = Math.floor(totalSeconds / 60);

      if (totalMinutes <= ProductPortalConstants.RefreshTokenTimeDifference && !this.isRefreshing) {
       
        this.isRefreshing = true;

        const body = new RefreshToken();
        body.userName = authorize!.username;

        this.refreshTokeUseCase.execute(body).subscribe((value) => {
          const newRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${value.token}`,
            },
          });

          this.isRefreshing = false;

          this.store.dispatch(new Login(value));

          return next.handle(newRequest);
        });
      }

      const request = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authorize!.token}`,
        },
      });

      return next.handle(request).pipe(
        catchError((error: any) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.logout();
          }

          return throwError(() => error);
        })
      );
    }

    return next.handle(req);
  }

   logout() {
    // Unauthorized error, redirect to login page
     this.store.reset({});
    this.store.dispatch(new Login(undefined));
    this.router.navigate(["/accounts/login"]).then();
   }
}
